import { Grid, List } from "react-feather";
import { Link } from "react-router-dom";
import { Href } from "../../../../../constants";
import { useAppDispatch } from "../../../../../reduxToolkit/hooks";
import { setColView, setListView } from "../../../../../reduxToolkit/reducers/eCommerce/filterSlice";

// This component provides toggle options to switch between grid view and list view for displaying products.
const ViewToggle = () => {

  const dispatch = useAppDispatch();
  const gridLayout = () => {
    dispatch(setListView(false));
    dispatch(setColView("col-xl-3 col-lg-4 col-sm-6"));
  };

  return (
    <>
      <div className="square-product-setting d-inline-block">
        <Link className="icon-grid" to={Href} onClick={gridLayout}>
          <Grid />
        </Link>
      </div>
      <div className="square-product-setting d-inline-block">
        <Link className="icon-grid m-0" to={Href} onClick={() => dispatch(setListView(true))}>
          <List />
        </Link>
      </div>
    </>
  );
};

export default ViewToggle;